module.exports = __webpack_public_path__ + "img/47.8.TSS.b3cbf18a.png";